<template>
  <div>
    <div class="page-head">
      <div>
        <h1 class="page-title">{{ isEdit ? 'Editar rol' : 'Crear rol' }}</h1>
        <p class="page-sub">Define el nombre y la descripción del perfil</p>
      </div>
    </div>

    <section class="section">
      <div class="box">
        <b-field label="Nombre">
          <b-input v-model="role.nombre"></b-input>
        </b-field>
        <b-field label="Descripción">
          <b-input type="textarea" v-model="role.descripcion"></b-input>
        </b-field>

        <b-button type="is-primary" @click="guardar">Guardar</b-button>
        <b-button @click="$router.push('/roles')">Cancelar</b-button>
      </div>
    </section>
  </div>
</template>

<script>
import HttpService from '@/Servicios/HttpService'
export default{
  name: 'RolesForm',
  data:()=>({ role: { nombre:'', descripcion:'' }, isEdit:false }),
  async mounted(){
    const id = this.$route.params.id
    if(id){
      this.isEdit = true
      const payload = { accion:'obtenerPorId', id }
      this.role = await HttpService.registrar('roles.php', payload)
    }
  },
  methods:{
    async guardar(){
      if(this.isEdit){
        await HttpService.registrar('roles.php', { accion:'editar', role: this.role })
      } else {
        await HttpService.registrar('roles.php', { accion:'registrar', role: this.role })
      }
      this.$router.push('/roles')
    }
  }
}
</script>
